var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCdmoPreClinicalCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
    fill: "#F5F0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 15.6665V20.6665C25.6666 20.9461 25.7368 21.2212 25.8709 21.4665L30.4626 29.8665C30.6014 30.1203 30.6719 30.406 30.6669 30.6953C30.6619 30.9846 30.5816 31.2676 30.4341 31.5165C30.2865 31.7654 30.0767 31.9716 29.8252 32.1148C29.5738 32.258 29.2894 32.3332 29.0001 32.3332H19.0001C18.7107 32.3332 18.4263 32.258 18.1749 32.1148C17.9234 31.9716 17.7136 31.7654 17.5661 31.5165C17.4185 31.2676 17.3383 30.9846 17.3333 30.6953C17.3283 30.406 17.3987 30.1203 17.5376 29.8665L22.1292 21.4665C22.2633 21.2212 22.3335 20.9461 22.3334 20.6665V15.6665",
    stroke: "#7C3AED",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3774 26.5H28.6224",
    stroke: "#7C3AED",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0834 15.6665H26.9167",
    stroke: "#7C3AED",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdmoPreClinicalCardIcon);
export default __webpack_public_path__ + "static/media/cdmo-Pre-clinical-card-icon.0b4f7e94fd140218f88037339eb6680e.svg";
export { ForwardRef as ReactComponent };